<template>
  <div class="container mt-1">
    <b-card>
      <!-- Form Section -->
      <form @submit.prevent="submitForm" class="row g-3 align-items-center">
        <div class="form-group row">
          <!-- Type of expenses -->
          <label for="SelectType" class="col-sm-1 text-start col-form-label">{{ $t('expense') }}</label>
          <div class="col-sm-3">
            <select id="SelectType" v-model="newExpense.expense" class="form-select" required>
              <option disabled value="">{{ $t('select_expense') }}</option>
              <option v-for="option in expenseOptions" :key="option.id" :value="option">
                {{ option.value }}
              </option>
            </select>
          </div>
          <!-- Value of expenses -->
          <label for="value" class="col-sm-1 text-start col-form-label">{{ $t('value') }}</label>
          <div class="col-sm-2">
            <div class="input-group">
              <input id="value" v-model="newExpense.value" type="number" class="form-control" :placeholder="$t('value')"
                required />
              <span class="input-group-text">€</span>
            </div>
          </div>
          <!-- Remarque -->
          <label for="remarque" class="col-sm-2 ml-4 text-start col-form-label">{{ $t('remarque') }}</label>
          <div class="col-sm-3">
            <input id="remarque" v-model="newExpense.remarque" type="text" class="form-control"
              :placeholder="$t('remarque')" />
          </div>
        </div>
        <div class="btn-update-cancel">
          <button class="btn btn-outline-success btn-sm me-2 btn-lg w-80">
            <i class="fas fa-save"></i> {{ isEditing ? $t('update') : $t('add') }}
          </button>
          <button class="btn btn-outline-danger btn-sm me-2 btn-lg w-80" type="reset" @click="resetForm">
            <i class="bi bi-x"></i> {{ $t('cancel') }}
          </button>
        </div>
      </form>
      <div class="card">
        <table class="custom-table">
          <thead>
            <tr>
              <th class="col-md-3">
                <input v-model="filters.expense" class="form-control form-control-sm" placeholder="Filter by Type" />
              </th>
              <th class="col-md-2">
                <input v-model="filters.value" type="number" class="form-control form-control-sm"
                  placeholder="Filter by Value" />
              </th>
              <th class="col-md-5">
                <input v-model="filters.remarque" class="form-control form-control-sm"
                  placeholder="Filter by Remarque" />
              </th>
              <th class="col-md-2">Actions</th>
            </tr>
            <tr>
              <th>Expense Type</th>
              <th>Value</th>
              <th>Remarque</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="expense in filteredExpenses" :key="expense.id">
              <td class="col-md-3">{{ getExpenseType(expense.expense.id) }}</td>
              <td class="col-md-2">{{ expense.value }}</td>
              <td class="col-md-5">{{ expense.remarque }}</td>
              <td class="col-md-2">
                <div class="btn-edit-delete">
                  <button class="btn btn-outline-primary btn-sm me-2" @click="editExpense(expense)">
                    <i class="fas fa-edit"></i>
                  </button>
                  <button class="btn btn-outline-danger btn-sm" @click="deleteExpense(expense.id)">
                    <i class="fas fa-trash"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td>Total</td>
              <td>{{ totalValue }}</td>
              <td colspan="2"></td>
            </tr>
          </tfoot>
        </table>
      </div>
    </b-card>
  </div>
</template>

<script>
import { Message } from "../libjs/alertService"; // Adjust the path

export default {
  props: ["movementId", "expenseOptions", "expenseMovements"],
  data() {
    return {
      expenses: [],
      filters: {
        //expense_id: "",
        expense: "",
        value: "",
        remarque: "",
      },
      newExpense: {
        id: "",
        //expense_id: "",
        expense: "",
        value: "",
        remarque: "",
      },
      isEditing: false,
      editingIndex: null,
    };
  },
  computed: {
    filteredExpenses() {
      return this.expenses.filter((expense) => {
        return (
          (this.filters.expense === "" ||
            this.getExpenseType(expense.expense)
              .toLowerCase()
              .includes(this.filters.expense.toLowerCase())) &&
          (this.filters.value === "" ||
            expense.value.toString().includes(this.filters.value)) &&
          (this.filters.remarque === "" ||
            expense.remarque.toLowerCase().includes(this.filters.remarque.toLowerCase()))
        );
      });
    },
    totalValue() {
      return this.expenses.reduce((sum, expense) => {
        return sum + Number(expense.value || 0);
      }, 0);
    },
  },
  watch: {
    totalValue(newValue) {
      this.$emit("updateTotalExpenses", newValue); // Emit totalValue whenever it changes
    },
  },
  methods: {
    getExpenseType(id) {
      //const option = this.expenseOptions.find((o) => o.value === id);
      console.log('id ' + id)
      console.log('expenseOptions: ' + JSON.stringify(this.expenseOptions))
      const option = this.expenseOptions.find((o) => o.id === id);
      console.log('option ' + option)
      return option ? option.value : "Unknown";
    },
    submitForm() {
      if (!this.newExpense.expense || !this.newExpense.value) {
        Message("warning", "Please fill in all required fields.");
        return;
      }

      if (this.isEditing) {
        // Update existing expense
        const expense = this.expenses[this.editingIndex];
        expense.expense = this.newExpense.expense;
        expense.value = Number(this.newExpense.value);
        expense.remarque = this.newExpense.remarque;

        Message("success", "Expense updated successfully.");
        this.isEditing = false;
        this.editingIndex = null;
      } else {
        // Add new expense
        this.expenses.push({
          id: null,
          movement_id: this.movementId,
          expense: this.newExpense.expense, //expense_id change to expense
          value: Number(this.newExpense.value),
          remarque: this.newExpense.remarque,
        });

        Message("success", "Expense added successfully.");
      }

      this.resetForm();
    },
    resetForm() {
      this.newExpense = { expense: "", value: "", remarque: "" };
    },
    resetTable() {
      this.expenses = []
    },
    editExpense(expense) {
      this.isEditing = true;
      this.editingIndex = this.expenses.indexOf(expense);
      this.newExpense = { ...expense };
    },
    deleteExpense(id) {
      this.expenses = this.expenses.filter((expense) => expense.id !== id);
      Message("success", "Expense deleted successfully.");
    },
    validateTable() {
      if (!this.expenses.length > 0) {
        Message("warning", this.$t("You need to fill Expense Movement"));
        return false;
      }
      return true;
    }
  },
  mounted() {
    this.expenses = this.expenseMovements
    this.$emit("updateTotalExpenses", this.totalValue); // Emit initial totalValue
  }
};
</script>

<!--style scoped>
/* General Form Styling */
form {
  background: #f8f9fa;
  padding: 10px;
  border-radius: 5px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.table th input {
  margin-bottom: 5px;
}

/* Responsive Table */
.table-responsive {
  overflow-x: auto;
}

.table th,
.table td {
  text-align: center;
  vertical-align: middle;
}

/* Button Styles */
button {
  font-size: 14px;
}

tfoot td {
  font-weight: bold;
}
</style-->
<style scoped>
/* General Styling */
body,
input,
button {
  font-family: "Arial", sans-serif;
  font-size: 14px;
}

tbody th {
  font-weight: normal !important;
}

tfoot td {
  font-weight: bold;
}

/* Form Styles */
form {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 15px;
  margin: 1px;
}

form input {
  flex: 1;
  padding: 6px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

form button {
  padding: 6px 12px;
  font-size: 14px;
  border-radius: 4px;
  cursor: pointer;
}

form button[type="submit"] {
  background-color: #28a745;
  color: #fff;
}

form button[type="submit"]:hover {
  background-color: #218838;
}

/* Table Styles */
.custom-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  margin-top: 20px;
}

.custom-table thead tr {
  background-color: #f2f2f2;
}

.custom-table th,
.custom-table td {
  border: 1px solid #ddd;
  padding: 6px;
  text-align: center;
}

.custom-table tbody tr:nth-child(even) {
  background-color: #fafafa;
}

.custom-table tbody tr:hover {
  background-color: #f1f1f1;
}

/* Filter Input Styling */
.filter-input {
  width: 100%;
  padding: 6px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  box-sizing: border-box;
}

/* Button Styles */
.edit-btn,
.delete-btn {
  padding: 6px 12px;
  border: none;
  border-radius: 3px;
  font-size: 14px;
  cursor: pointer;
}

.edit-btn {
  background-color: #007bff;
  color: white;
  margin-right: 5px;
}

.edit-btn:hover {
  background-color: #0056b3;
}

.delete-btn {
  background-color: #dc3545;
  color: white;
}

.delete-btn:hover {
  background-color: #c82333;
}

/* Remove arrows in Chrome, Safari, Edge, and Opera */
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Responsive Styles */
@media (max-width: 768px) {
  .btn {
    font-size: 0.9rem;
  }

  table {
    font-size: 0.85rem;
  }

  h1 {
    font-size: 2rem;
  }
}

html[lang="ar"] {
  direction: rtl;
  text-align: right;
}
</style>
